// extracted by mini-css-extract-plugin
export default {"container":"container-02007","item":"item-02007","shine":"shine-02007"};